import { Injectable } from '@angular/core';
import { ProductAttachment, ProductDetail } from '../model/products.model';
import { BASE_ROOT_URL,URL_DATA_API } from '../constant.var';
import { Observable } from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { CurrentUser } from '../model/user.model';
import { AuthService } from './auth.service';
@Injectable({
  providedIn: 'root'
})
export class OrderResultsService {
  currentImage: ProductAttachment;
  currentProduct: ProductDetail;
  currentUser: CurrentUser;

  constructor(private http: HttpClient,
    private authenticationService: AuthService
    ) { 
    this.currentUser = this.authenticationService.currentUserValue;
  }

 public getProducts(): Observable<any>  {
    return this.http.get(`${BASE_ROOT_URL}/crm/orderResultAttachment`);
  }
 public getOderTable(pageSize:number,pageIndex :number):  Observable<any> {
   pageIndex=pageIndex+1;
  const headers = new HttpHeaders({
    'Authorization': this.currentUser.access_token,
    'Content-Type': `application/json`
  });
  var url = `${URL_DATA_API}/orders?pageIndex=${pageIndex}&pageSize=${pageSize}`;
  var requestOptions = {
    headers: headers,
    };
        
    return this.http.get(url,requestOptions);
 } 
 public deleteList(data): Observable<any>{
   console.log("vào delete");
  const headers = new HttpHeaders({
    'Authorization': this.currentUser.access_token,
    'Content-Type': 'application/json'});
  const options = { headers: headers };
  var url = `${URL_DATA_API}/orders/delete/${data}`;
  console.log(url);
  return this.http.get(url,options);
}

  getProduct(productId) {
    return this.http.get(`${BASE_ROOT_URL}/crm/products/${productId}`);
  }
}
